/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');

  }, 6000)

};

sections.extend('slideshow', slideshowAutoExtension);


;; ($ => {
  // SHP_SHISEIAGRI-7 ----------------------------------------------
  if($.querySelector('#ContactForm-prefectures')) {
    let selectPrefectures = $.querySelector('#ContactForm-prefectures').dataset.default;
    if(selectPrefectures) {
      let prefecturesList = $.querySelectorAll('#ContactForm-prefectures option');
      [...prefecturesList].map((elem, i) => {
        if(elem.text === selectPrefectures) {
          elem.setAttribute('selected', 'selected');
        }
      });
    }
  }

  // SHP_SHISEIAGRI-16 ---------------------------------------------
  window.addEventListener('load', () => {
    if($.querySelectorAll('.js-prefectures')) {
      let selectPrefectures = $.querySelectorAll('.js-prefectures');
      [...selectPrefectures].map((elem, i) => {
        if(elem.dataset.default) {
          let defaultrPefectures = elem.dataset.default;
          let prefecturesList = elem.querySelectorAll('.js-prefectures option');
          [...prefecturesList].map((elem, i) => {
            if(elem.text === defaultrPefectures) {
              elem.setAttribute('selected', 'selected');
            }
          });
        }
      });
    }
  });
})(document);
